import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL;

const http = axios.create({
    baseURL: API_URL,
    // headers: {
    //     "Content-type": "application/json",
    // },
    headers: authHeader(),
});

const getAll = () => {
    return http.get("/supplier");
};

const get = (id) => {
    return http.get(`/supplier/${id}`);
};

const getCostStats = (id) => {
    return http.get(`/supplier/${id}/cost-stats`);
};

const create = (name, costCenterId) => {
    return http.post("/supplier", {
        name,
        costCenterId,
    });
};

const update = (id, name) => {
    return http.put(`/supplier/${id}`, name);
};

const remove = (id) => {
    return http.delete(`/supplier/${id}`);
};

const removeAll = () => {
    return http.delete(`/supplier`);
};

const findByName = (name) => {
    return http.get(`/supplier`, {
        params: {
            name: name,
        },
    });
};

const SupplierService = {
    getAll,
    get,
    getCostStats,
    create,
    update,
    remove,
    removeAll,
    findByName,
};

export default SupplierService;
